module.exports = __webpack_public_path__ + "static/media/c1.0ee35d6e.png";